import styled from "styled-components";

export const FestivalEventImageBanner = styled.div`
  position: relative;
  width: 100%;
  height: 360px;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  > .back {
    width: 100%;
    height: 100%;
    top: 0;
    position: absolute;
    background: linear-gradient(
      180deg,
      rgba(18, 18, 18, 0) 51.08%,
      #121212 85.49%
    );
  }
`;

export const FestivalEventBannerText = styled.div`
  position: absolute;
  left: 16px;
  bottom: 30px;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 2px;

  > .address {
    height: 30px;
    border-radius: 8px;
    padding: 0 16px;
    background: #6436e7;
    font-weight: 600;
    font-size: 12px;
    line-height: 30px;
    text-align: center;
    width: max-content;
  }

  > .title {
    font-weight: 700;
    font-size: 24px;
  }

  > .subTitle {
    margin-top: 2px;
    font-weight: 500;
    font-size: 14px;
  }
`;
